export const Reviews = () => {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="py-20 px-6 max-w-4xl mx-auto border-b border-[var(--line)] text-center"
    >
      <span className="label-caps text-[11px] text-[var(--ink)]/70">Customer Journal</span>
      <h2 className="serif-head text-3xl sm:text-4xl text-[var(--ink)] mt-2 mb-4">Reviews</h2>
      <div
        data-testid="reviews-empty-state"
        className="border border-dashed border-[var(--line-strong)] p-12 bg-[var(--card-bg)]/60"
      >
        <div className="serif-head text-xl text-[var(--ink)]">
          Reviews from our first guests will appear here
        </div>
        <p className="text-xs text-[var(--ink)]/70 mt-2 max-w-md mx-auto font-light">
          Our initial release is in transit. Customer feedback and scent impressions will be
          documented here.
        </p>
      </div>
    </section>
  );
};
